import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import { ChevronRight } from 'lucide-react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import {
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@/components/ui/sidebar';
import { iconShape } from '../../../../../../../../../shared/types';
import { NavContext } from '../../../../../../../context/Nav';

const chevronRightClasses = [
  'ml-auto',
  'transition-transform',
  'duration-200',
  'group-data-[state=open]/collapsible:rotate-90',
].join(' ');

const ChildLinks = ({ links }) => (
  <CollapsibleContent>
    <SidebarMenuSub>
      {links.map(({ label, path }) => (
        <SidebarMenuSubItem key={label}>
          <NavLink to={path}>
            {({ isActive }) => (
              <SidebarMenuSubButton asChild isActive={isActive}>
                <span>{label}</span>
              </SidebarMenuSubButton>
            )}
          </NavLink>
        </SidebarMenuSubItem>
      ))}
    </SidebarMenuSub>
  </CollapsibleContent>
);

ChildLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const ParentLink = ({ icon, label }) => (
  <CollapsibleTrigger asChild>
    <SidebarMenuButton tooltip={label}>
      <FontAwesomeIcon icon={icon} />
      <span>{label}</span>
      <ChevronRight className={chevronRightClasses} />
    </SidebarMenuButton>
  </CollapsibleTrigger>
);

ParentLink.propTypes = {
  icon: iconShape.isRequired,
  label: PropTypes.string.isRequired,
};

const LinkWithChildren = ({ link }) => {
  const { hasActiveNestedLink } = useContext(NavContext);

  const { icon, label, nestedLinks } = link;

  return (
    <Collapsible
      asChild
      className="group/collapsible"
      defaultOpen={hasActiveNestedLink(link)}
      key={label}
    >
      <SidebarMenuItem>
        <ParentLink icon={icon} label={label} />
        <ChildLinks links={nestedLinks} />
      </SidebarMenuItem>
    </Collapsible>
  );
};

LinkWithChildren.propTypes = {
  link: PropTypes.shape({
    icon: iconShape.isRequired,
    label: PropTypes.string.isRequired,
    nestedLinks: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export default LinkWithChildren;
